import { getCost, theme } from 'lib';
import { store } from 'store';

/*
  Theme to be used on chart visuals and section bg
*/
function getType(type) {
  /*
    TODO: Should update label per i18n
  */
  if (type === 'shoutout') {
    return {
      color: theme.SECONDARY,
      label: 'Shoutouts'
    };
  }

  if (type === 'connect') {
    return {
      color: theme.PINK,
      label: 'Connects'
    };
  }

  if (type === 'referral') {
    return {
      color: theme.DARK_PURPLE,
      label: 'Referrals'
    };
  }

  if (type === 'subscription') {
    return {
      color: theme.GREY_10,
      label: 'Subscriptions'
    };
  }
}

/*
  Filter by service type
*/
function filterByType(data, type) {
  const user = store.getState().user,
    userCurrency = user.billing?.currency || 'usd';

  const filtered = data.filter((x) => x.type === type);

  /*
    For referrals, individual user count
  */
  let users = new Set();

  const total = filtered.reduce((x, y) => {
    if (type === 'referral') users.add(y.entityId);
    const cost = getCost(y.rates, y.currency, y.amount);

    return x + (cost.convertedPrice - (y.fee / 100) * cost.convertedPrice) / 100;
  }, 0);

  const count = filtered.length;

  if (!type) return;
  const { color, label } = getType(type);

  return {
    type,
    total,
    count,
    color,
    label,
    users: users.size,
    value: total,
    currency: userCurrency
  };
}

export default filterByType;
